import clsx from 'clsx';
import { createPortal } from 'react-dom';

import s from './HeaderNavigation.module.css';

export const HeaderNavigationFlyout = ({
	companies,
	isCompanyMode,
	activeCompanyId,
	onCompanySelect,
	floatingRef,
	floatingStyles,
}) => {
	return createPortal(
		<div
			ref={floatingRef}
			style={{ ...floatingStyles, zIndex: 1201 }}
			className={clsx('nav-dropdown', 'scrollbar-y', 'dropdown-navigation__companies', s.flyoutPanel)}
			role='menu'
		>
			{companies.map((company) => {
				const isActive = isCompanyMode && company.id === activeCompanyId;

				return (
					<button
						key={company.id}
						type='button'
						className={clsx('list-item', isActive && 'list-item--active')}
						onClick={() => onCompanySelect(company.id)}
						role='menuitem'
					>
						<span className='body-medium-sm list-item__text'>{company.name}</span>
					</button>
				);
			})}
		</div>,
		document.body,
	);
};
